import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'react-bootstrap';

const ItemsContract = ({ id, title, text, isLast, itemEdit, itemDelet }) => {
 return (
  <Row className={classNames('g-3', { 'pb-x1': !isLast })}>
   <Col className="">
    <Row className={classNames('g-3', { 'border-bottom pb-x1': !isLast })}>
     <Col>
      <h6 className="text-800 mb-0">{title}</h6>
      <p className="fs--1 text-600 mb-0">{text}</p>
     </Col>
     <Col xs="auto" className="px-0 d-md-flex">
      <Button variant="link" className="p-0 icon-item icon-item-sm" onClick={() => itemEdit({ id, title, text })}>
       <FontAwesomeIcon icon="pencil-alt" />
      </Button>
      <Button variant="link" className="p-0 icon-item icon-item-sm" onClick={() => itemDelet(id)}>
       <FontAwesomeIcon icon="trash-alt" />
      </Button>
     </Col>
    </Row>
   </Col>
  </Row>
 );
};

ItemsContract.propTypes = {
 id: PropTypes.string,
 title: PropTypes.string,
 text: PropTypes.string,
 isLast: PropTypes.bool,
 itemEdit: PropTypes.func,
 itemDelet: PropTypes.func
};

export default ItemsContract;
